module.exports = __webpack_public_path__ + "static/media/ALD Logo.646e5fc0.png";